import { toast } from "../components/razor-reuse";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { toast } from "react-toastify";
import axios from "../utils/axios";
import {
  ApprovalSettingsPayload,
  GetApprovalSettingsParams,
  CountryOption,
  notificationProp,
  SettingsState,
} from "./type";
import { generateQueryString } from "../helper/helpers";

interface LoginPayload {
  // Add appropriate types for the payload
}

export const getAllCurrencies = createAsyncThunk(
  "web/get-all-available-currency",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/list-currencies`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        

        thunkAPI.dispatch(SET_CURRENCIES_DROP(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getAllCountries = createAsyncThunk(
  "web/get-all-countries",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/list-countries`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;

        thunkAPI.dispatch(SET_COUNTRIES_DROP(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

// Nationality countries for the notification audience "Country" filter.
// Kept separate from getAllCountries/all_countries_drop, whose options use the
// country id as value — this list uses iso3_code.
export const getNationalityCountries = createAsyncThunk(
  "web/get-nationality-countries",
  async (_payload: void, thunkAPI) => {
    try {
      const data: any = await axios.get(
        `/admin/list-countries${generateQueryString({
          country_type: "nationality",
        })}`,
      );

      // The shared axios interceptor resolves failed requests (returning the
      // error, or nothing) instead of throwing, so anything that isn't a
      // successful response with a list is treated as a failure here.
      const list = data?.data?.data;
      if (
        !data ||
        data?.isAxiosError ||
        !data?.data?.status ||
        data?.data?.status === "fail" ||
        !Array.isArray(list)
      ) {
        return thunkAPI.rejectWithValue(data?.data?.message || null);
      }

      thunkAPI.dispatch(SET_NATIONALITY_COUNTRIES(list));
      return list.length;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || null);
    }
  },
  {
    // The list is static for the session: fetch it once, don't start a second
    // request while one is in flight, and only re-fetch after a failure.
    condition: (_payload, { getState }) => {
      const { settings } = getState() as { settings: SettingsState };
      const status = settings?.nationality_countries_status;
      return status !== "loading" && status !== "succeeded";
    },
  }
);

export const getAllExchangeRate = createAsyncThunk(
  "web/get-all-exchange-rate",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/exchange-rates/all?page=${payload?.page || 1}${
          payload?.status ? `&filter[status]=${payload?.status}` : ``
        }${payload?.search ? `&search=${payload?.search}` : ``}`
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;

        thunkAPI.dispatch(SET_ALL_EXCHANGE_RATE(obj));
        return data;
      }
      return data;
    } catch (error: any) {

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getAllExchangeRateHistory = createAsyncThunk(
  "web/get-all-exchange-rate-history",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/exchange-rates/history/${
          payload?.id || localStorage?.getItem("cur-his-id")
        }/?page=${payload?.page || 1}${
          payload?.status ? `&filter[status]=${payload?.status}` : ``
        }${payload?.search ? `&search=${payload?.search}` : ``}`
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        thunkAPI.dispatch(SET_ALL_EXCHANGE_RATE_HISTORY(obj));
        return data;
      }
      return data;
    } catch (error: any) {
  

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getExchangeRateForCreate = createAsyncThunk(
  "web/get-exchange-rate-for-create",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/exchange-rates/get-fx-rates?${
          payload?.source_currency
            ? `source_currency=${payload?.source_currency}`
            : ``
        }${
          payload?.destination_currency
            ? `&destination_currency=${payload?.destination_currency}`
            : ``
        }${payload?.provider ? `&provider=${payload?.provider}` : ``}`
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        // const obj = data?.data;
        return data;
      }
      return data;
    } catch (error: any) {

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const createExchangeRate = createAsyncThunk(
  "web/create-exchange-rate",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const data = await axios.post("/admin/exchange-rates", payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  "web/update-user-profile",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const data = await axios.post("/admin/updateProfile", payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const updateUserPassword = createAsyncThunk(
  "web/update-user-password",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const data = await axios.post("/admin/account/changePassword", payload);
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const EditExchangeRate = createAsyncThunk(
  "web/edit-exchange-rate",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.patch(
        `/admin/exchange-rates/${payload?.id}`,
        payload
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const activateExchangeRate = createAsyncThunk(
  "web/activate-exchange-rate",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.patch(
        `/admin/exchange-rates/activate/${payload?.id}`,
        payload
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const deactivateExchangeRate = createAsyncThunk(
  "web/deactivate-exchange-rate",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.patch(
        `/admin/exchange-rates/deactivate/${payload?.id}`,
        payload
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const get2FASetup = createAsyncThunk(
  "web/setup-mfa",
  async (_payload: any, thunkAPI) => {
    try {
      const data = await axios.post(`/2fa/setup`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        

        thunkAPI.dispatch(SETUP_2FA(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const verify2FA = createAsyncThunk(
  "web/verify-mfa",
  async (
    payload: {
      obj: {
        secret: string;
      };
      tk?: string;
    },
    thunkAPI
  ) => {
    try {
      const data = await axios.post(
        "/2fa/verify",
        payload.obj,
        payload.tk
          ? {
              headers: {
                Authorization: `Bearer ${payload.tk?.toString()}`,
              },
            }
          : {}
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status && !payload.tk) {
        toast.success(data?.data?.message || "2FA Enabled Successfully", {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const disabled2FA = createAsyncThunk(
  "web/disable-mfa",
  async (
    payload: {
      secret: string;
    },
    thunkAPI
  ) => {
    try {
      const data = await axios.post("/2fa/disable", payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(
          data?.data?.message ||
            "Your 2FA authentication was confirmed and deactivated successfully",
          {
            position: "top-right",
            theme: "colored",
          }
        );

        return data;
      }
      return data;
    } catch (error: any) {
      // console.log({ error });

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getNotificationSettings = createAsyncThunk(
  "web/get-notification-settings",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/notification/settings/preferences`);
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data?.notification_preference;

        thunkAPI.dispatch(SET_NOTIFICATION(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const updateNotificationSettings = createAsyncThunk(
  "web/update-notification-settings",
  async (data: notificationProp[], thunkAPI) => {
    const payload = { notification_preference: data };

    try {
      const data = await axios.post(
        "/admin/notification/settings/preferences",
        payload
      );
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getApprovalSettings = createAsyncThunk(
  "web/get-approval-settings",
  async (payload: GetApprovalSettingsParams, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/approval-settings${generateQueryString({
          type: payload?.type,
        })}`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;

        thunkAPI.dispatch(SET_APPROVAL_SETTINGS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const updateApprovalSettings = createAsyncThunk(
  "web/update-approval-settings",
  async (payload: ApprovalSettingsPayload, thunkAPI) => {
    try {
      const data = await axios.post(`/admin/approval-settings`, payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_APPROVAL_SETTINGS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

const initialState: SettingsState = {
  loading: false,
  all_currencies_drop: [],
  all_countries_drop: [],
  exchange_rates: {},
  exchange_rates_history: {},
  loadingDelete: false,
  loadingFetch: false,
  loading_mfa: false,
  setup_mfa: {},
  notification_pref: null,
  loading_notification: false,
  mutation_notification: false,
  approval_settings: undefined,
  loading_approval_settings: false,
  mutation_approval_settings: false,
  nationality_countries: [],
  nationality_countries_status: "idle",
  // initialize other state properties
};

// Skips entries without a usable name/iso3_code, drops duplicate codes and
// sorts by name, so the dropdown never shows blank or repeated options.
const toNationalityCountryOptions = (list: any[]): CountryOption[] => {
  const seen = new Set<string>();
  const options: CountryOption[] = [];

  list.forEach((country) => {
    const label = typeof country?.name === "string" ? country.name.trim() : "";
    const value =
      typeof country?.iso3_code === "string" ? country.iso3_code.trim() : "";
    const key = value.toUpperCase();

    if (!label || !value || seen.has(key)) return;
    seen.add(key);
    options.push({ label, value });
  });

  return options.sort((a, b) => a.label.localeCompare(b.label));
};

const addLabelValue = (list: any) => {
  if (list?.length > 0) {
    const newList = list?.map((chi: any) => {
      return { ...chi, label: chi?.code, value: chi?.id };
    });
    return newList;
  }
};

const addCountryLabelValue = (list: any) => {
  if (list?.length > 0) {
    const newList = list?.map((chi: any) => {
      return {
        ...chi,
        label: chi?.name,
        value: chi?.id,
        imageUrl: chi?.flag_url,
      };
    });
    return newList;
  }
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,

  reducers: {
    SET_ALL_EXCHANGE_RATE: (state, action) => {
      state.exchange_rates = action.payload;
    },
    SET_ALL_EXCHANGE_RATE_HISTORY: (state, action) => {
      state.exchange_rates_history = action.payload;
    },
    SET_CURRENCIES_DROP: (state, action) => {
      state.all_currencies_drop = addLabelValue(action.payload);
    },
    SET_COUNTRIES_DROP: (state, action) => {
      state.all_countries_drop = addCountryLabelValue(action.payload);
    },
    SET_NATIONALITY_COUNTRIES: (state, action) => {
      state.nationality_countries = toNationalityCountryOptions(action.payload);
    },
    SETUP_2FA: (state, action) => {
      state.setup_mfa = action.payload;
    },
    SET_NOTIFICATION: (state, action) => {
      state.notification_pref = action.payload;
    },
    SET_APPROVAL_SETTINGS: (state, action) => {
      state.approval_settings = action.payload;
    },
  },

  extraReducers: (builder) => {
    // pending state changes
    // Unlike the other cases, a failure here only flags this list as failed
    // (so the UI can offer a retry) rather than resetting the whole slice.
    builder.addCase(getNationalityCountries.pending, (state) => {
      state.nationality_countries_status = "loading";
    });
    builder.addCase(getNationalityCountries.fulfilled, (state) => {
      state.nationality_countries_status = "succeeded";
    });
    builder.addCase(getNationalityCountries.rejected, (state) => {
      state.nationality_countries_status = "failed";
    });
    builder.addCase(getAllExchangeRate.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllExchangeRate.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getAllExchangeRate.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(getAllExchangeRateHistory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllExchangeRateHistory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getAllExchangeRateHistory.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(EditExchangeRate.pending, (state) => {
      state.loadingDelete = true;
    });
    builder.addCase(EditExchangeRate.fulfilled, (state) => {
      state.loadingDelete = false;
    });
    builder.addCase(EditExchangeRate.rejected, (state) => {
      state.loadingDelete = false;
    });
    builder.addCase(createExchangeRate.pending, (state) => {
      state.loadingDelete = true;
    });
    builder.addCase(createExchangeRate.fulfilled, (state) => {
      state.loadingDelete = false;
    });
    builder.addCase(createExchangeRate.rejected, (state) => {
      state.loadingDelete = false;
    });
    builder.addCase(deactivateExchangeRate.pending, (state) => {
      state.loadingDelete = true;
    });
    builder.addCase(deactivateExchangeRate.fulfilled, (state) => {
      state.loadingDelete = false;
    });
    builder.addCase(deactivateExchangeRate.rejected, (state) => {
      state.loadingDelete = false;
    });
    builder.addCase(activateExchangeRate.pending, (state) => {
      state.loadingDelete = true;
    });
    builder.addCase(activateExchangeRate.fulfilled, (state) => {
      state.loadingDelete = false;
    });
    builder.addCase(activateExchangeRate.rejected, (state) => {
      state.loadingDelete = false;
    });
    builder.addCase(updateUserProfile.pending, (state) => {
      state.loadingDelete = true;
    });
    builder.addCase(updateUserProfile.fulfilled, (state) => {
      state.loadingDelete = false;
    });
    builder.addCase(updateUserProfile.rejected, (state) => {
      state.loadingDelete = false;
    });
    builder.addCase(updateUserPassword.pending, (state) => {
      state.loadingDelete = true;
    });
    builder.addCase(updateUserPassword.fulfilled, (state) => {
      state.loadingDelete = false;
    });
    builder.addCase(updateUserPassword.rejected, (state) => {
      state.loadingDelete = false;
    });
    builder.addCase(getExchangeRateForCreate.pending, (state) => {
      state.loadingFetch = true;
    });
    builder.addCase(getExchangeRateForCreate.fulfilled, (state) => {
      state.loadingFetch = false;
    });
    builder.addCase(getExchangeRateForCreate.rejected, (state) => {
      state.loadingFetch = false;
    });
    builder.addCase(get2FASetup.pending, (state) => {
      state.loading_mfa = true;
    });
    builder.addCase(get2FASetup.fulfilled, (state) => {
      state.loading_mfa = false;
    });
    builder.addCase(get2FASetup.rejected, (state) => {
      state.loading_mfa = false;
    });
    builder.addCase(verify2FA.pending, (state) => {
      state.loading_mfa = true;
    });
    builder.addCase(verify2FA.fulfilled, (state) => {
      state.loading_mfa = false;
    });
    builder.addCase(verify2FA.rejected, (state) => {
      state.loading_mfa = false;
    });
    builder.addCase(disabled2FA.pending, (state) => {
      state.loading_mfa = true;
    });
    builder.addCase(disabled2FA.fulfilled, (state) => {
      state.loading_mfa = false;
    });
    builder.addCase(disabled2FA.rejected, (state) => {
      state.loading_mfa = false;
    });
    builder.addCase(getNotificationSettings.pending, (state) => {
      state.loading_notification = true;
    });
    builder.addCase(getNotificationSettings.fulfilled, (state) => {
      state.loading_notification = false;
    });
    builder.addCase(getNotificationSettings.rejected, (state) => {
      state.loading_notification = false;
      return initialState;
    });
    builder.addCase(updateNotificationSettings.pending, (state) => {
      state.mutation_notification = true;
    });
    builder.addCase(updateNotificationSettings.fulfilled, (state) => {
      state.mutation_notification = false;
    });
    builder.addCase(updateNotificationSettings.rejected, (state) => {
      state.mutation_notification = false;
    });
    builder.addCase(getApprovalSettings.pending, (state) => {
      state.loading_approval_settings = true;
    });
    builder.addCase(getApprovalSettings.fulfilled, (state) => {
      state.loading_approval_settings = false;
    });
    builder.addCase(getApprovalSettings.rejected, (state) => {
      state.loading_approval_settings = false;
    });
    builder.addCase(updateApprovalSettings.pending, (state) => {
      state.mutation_approval_settings = true;
    });
    builder.addCase(updateApprovalSettings.fulfilled, (state) => {
      state.mutation_approval_settings = false;
    });
    builder.addCase(updateApprovalSettings.rejected, (state) => {
      state.mutation_approval_settings = false;
    });
  },
});

// Action creators are generated for each case reducer function
export const {
  SET_CURRENCIES_DROP,
  SET_COUNTRIES_DROP,
  SET_NATIONALITY_COUNTRIES,
  SET_ALL_EXCHANGE_RATE,
  SET_ALL_EXCHANGE_RATE_HISTORY,
  SETUP_2FA,
  SET_NOTIFICATION,
  SET_APPROVAL_SETTINGS,
} = settingsSlice.actions;

export default settingsSlice.reducer;
